module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindentd"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("All the incidents in this story are real. They did not happen in just the order they are recorded, but they all happened at one time or another on the little island of Chincoteague.")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 66
// module chunks = 0